<template>
  <div>
    <Splide
      v-if="!$vuetify.display.mobile"
      :options="{ options }"
      :has-track="false"
      aria-label="Bildergalerie der Schreinerei M²"
      id="splide"
    >
      <SplideTrack>
        <SplideSlide
          v-for="image in images"
          :key="image.alt"
        >
          <v-img
            :lazy-src="require('./../assets/images/' + image.src + '_lowres.jpg')"
            transition="true"
            :alt="image.alt"
            cover
            class="hero-image"
            :src="require('./../assets/images/' + image.src + '.jpg')"
          ></v-img>
        </SplideSlide>
      </SplideTrack>
    </Splide>
    <v-img
      v-else
      cover
      class="hero-image-mobile"
      :lazy-src="require('./../assets/images/' + images[0].src + '_lowres.jpg')"
      transition="true"
      :alt="images[0].alt"
      :src="require('./../assets/images/' + images[0].src + '.jpg')"
    ></v-img>

    <div class="text-center my-10">
      <h1 class="brand-title text-accent">schreinerei m²</h1>
      <p class="brand-subtitle text-primary mt-2">Pfullingen bei Reutlingen</p>
    </div>

    <v-card class="bg-surface pa-6 pa-md-8 my-6 card-clean" elevation="1">
      <h2 class="section-title mb-4">Individuelle Schreinerei aus Pfullingen</h2>
      <p class="body-text">
        Wir sind ein innovatives Handwerksunternehmen, das sich genau Ihren Wünschen und
        Vorstellungen anpasst! Ob ein speziell gefertigtes Möbelstück, eine Küche oder
        eine komplette Inneneinrichtung. Unsere Schreinerei steht für nachhaltige und
        ressourcenschonende Produkte. Dabei orientieren wir uns bei der Auswahl von allen
        Materialien an zertifizierten Produkten die nachhaltig angebaut und produziert
        wurden.
      </p>
    </v-card>

    <div class="services-overview my-8 text-center">
      <v-row>
        <v-col
          v-for="category in categories"
          :key="category.title"
          cols="6"
          sm="4"
          md="3"
        >
          <router-link :to="'/leistungen#' + category.anchor" class="service-chip">
            <v-icon class="mb-1" size="28" color="accent">{{ category.icon }}</v-icon>
            <span>{{ category.title }}</span>
          </router-link>
        </v-col>
      </v-row>
    </div>

    <v-card class="bg-primary pa-6 pa-md-8 my-6 card-clean text-center" elevation="0">
      <h2 class="text-accent mb-2">Ihr Projekt beginnt mit einem Gespräch</h2>
      <p class="body-text text-accent mb-5" style="opacity: 0.85">
        Wir planen, fertigen und montieren für Sie nach Ihren individuellen Wünschen –
        kommen Sie mit Ihren Ideen gerne auf uns zu!
      </p>
      <div class="d-flex flex-column flex-md-row justify-center align-center">
        <v-btn
          size="large"
          class="bg-accent text-primary ma-2"
          href="tel:+4915778204841"
        >
          <v-icon start>mdi-phone</v-icon>
          +49 1577 8204841
        </v-btn>
        <v-btn
          size="large"
          class="bg-accent text-primary ma-2"
          to="/contact"
        >
          <v-icon start>mdi-email</v-icon>
          Jetzt Kontakt aufnehmen
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
import "@splidejs/vue-splide/css";

export default {
  name: "Home",
  components: {
    Splide,
    SplideSlide,
    SplideTrack,
  },
  setup() {
    const images = require("../starting.csv");
    const options = {
      rewind: true,
      autoplay: true,
    };

    return { images, options };
  },
  data: () => ({
    categories: [
      { title: "Küchen", icon: "mdi-stove", anchor: "kuechen" },
      { title: "Wohnzimmer", icon: "mdi-sofa", anchor: "wohnzimmer" },
      { title: "Schlafzimmer", icon: "mdi-bed", anchor: "schlafzimmer" },
      { title: "Bad", icon: "mdi-shower", anchor: "bad" },
      { title: "Massivholzmöbel", icon: "mdi-tree", anchor: "massivholzmoebel" },
      { title: "Einbauschränke", icon: "mdi-wardrobe", anchor: "einbauschraenke" },
      { title: "Innenausbau", icon: "mdi-home-city", anchor: "innenausbau" },
      { title: "Ladenbau", icon: "mdi-store", anchor: "ladenbau" },
    ],
  }),
};
</script>

<style scoped>
#splide {
  left: 0;
  min-width: 100%;
  max-height: 65vh;
  overflow: clip;
  display: flex;
  flex-direction: column-reverse;
}

@media (max-width: 959px) {
  #splide {
    max-height: 50vh;
  }
}

.hero-image {
  min-height: 50vh;
}

.hero-image-mobile {
  height: 50vh;
  border-radius: 0 0 12px 12px;
}

.brand-title {
  font-size: clamp(2em, 6vw, 3.5em);
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-weight: 300;
}

.brand-subtitle {
  font-size: 1em;
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  opacity: 0.6;
}

.card-clean {
  border-radius: 12px;
}

.section-title {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 1.3em;
}

.body-text {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 1em;
  line-height: 1.7;
}

.service-chip {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: inherit;
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 0.85em;
  padding: 12px 8px;
  border-radius: 12px;
  transition: background-color 0.2s;
}

.service-chip:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
